import React from 'react';
import Slider from 'react-slick';
import './LatestTestimonials.css';
import t1 from '../components/assets/images/pro-1.jpg';
import t2 from '../components/assets/images/pro-10.jpg';
import t3 from '../components/assets/images/combo-1.webp';
import t4 from '../components/assets/images/combo-1.webp';
import t5 from '../components/assets/images/combo-7.webp';



const testimonials = [
    {
        product: 'Pure Himalayan Shilajit Resin',
        image: t1,
        rating: 5,
        text: "After just two weeks of daily use, my energy levels skyrocketed. I feel more focused at work and my afternoon slumps are gone. Pure Himalayan Shilajit Resin is now part of my morning ritual!",
        author: 'Neha S.',
        role: 'Marketing Manager',
    },
    {
        product: 'Gold-Grade Shilajit Capsules',
        image: t2,
        rating: 5,
        text: "I’ve tried many supplements for stamina, but these Gold-Grade Shilajit Capsules truly deliver. My workouts have never felt better, and recovery is so much faster. Highly recommend!",
        author: 'Arjun P.',
        role: 'Fitness Trainer',
    },
    {
        product: 'Shilajit & Ashwagandha Combo',
        image: t3,
        rating: 5,
        text: "The synergy of Shilajit with Ashwagandha has transformed my stress levels. I’m sleeping deeper, waking up refreshed, and my mind feels calm yet alert throughout the day.",
        author: 'Priya K.',
        role: 'Yoga Instructor',
    },
    {
        product: 'Premium Shilajit Powder',
        image: t4,
        rating: 5,
        text: "I mix this Premium Shilajit Powder into my morning smoothie. Within days, I noticed improved digestion, better mood, and sustained energy without jitters. A game-changer!",
        author: 'Rahul M.',
        role: 'Nutritionist',
    },
    {
        product: 'Royal Shilajit Resin with Saffron',
        image: t5,
        rating: 5,
        text: "This Royal Shilajit Resin with Saffron not only boosted my immunity but also gave my skin a healthy glow. Such a luxurious yet powerful supplement—totally worth it!",
        author: 'Sneha R.',
        role: 'Wellness Blogger',
    },
];

export default function LatestTestimonials() {
    const settings = {
        dots: true,
        infinite: true,
        speed: 800,
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '0px',
        arrows: true,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 2 } },
            { breakpoint: 768, settings: { slidesToShow: 1, centerMode: false } },
        ],
    };

    return (
        <div className="testimonials-wrapper">
            <section className="testimonials-section">
                <h2 className="section-title">LATEST <span className="verified">TESTIMONIALS</span> </h2>
                <Slider {...settings} className="testimonials-slider">
                    {testimonials.map((t, i) => (
                        <div key={i} className="testimonial-card">
                            <div className="card-header">
                                <div className="product-name">{t.product}</div>
                                <img src={t.image} alt={t.product} className="author-img" />
                            </div>
                            <div className="stars">{'★'.repeat(t.rating)}</div>
                            <p className="testimonial-text">{t.text}</p>
                            <div className="author-info">
                                <div className="author-name">{t.author}</div>
                                <div className="author-role">{t.role}</div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </section>
        </div>
    );
}
